import {
  removeFolder,
  removeMessage,
  setWorkflowStep,
} from "../../store/reducers/root";
import prepareMessage from "../prepareMessage";
import { CustomFile } from "telegram/client/uploads";
import { readFileAsArrayBuffer } from "../readFileAsArrayBuffer";
import { sleep } from "telegram/Helpers";
import * as Sentry from "@sentry/react";

export default async function sendFile(props) {
  const { client, dispatch, folder, message, files } = props;

  await client.connect();
  await client.getDialogs({
    folderId: folder.folderOrder,
    limit: 1000,
  });

  const errors = {
    CHAT_WRITE_FORBIDDEN: 0,
    CHAT_ADMIN_REQUIRED: 0,
    OTHERS: 0,
    CHATS_WITH_ERRORS: [],
  };

  const formattedMessage = await prepareMessage(client, folder, message);
  let index = 0;
  let success = 0;
  let result, linkToTg;

  for (const channel of folder.channels) {
    try {
      const filesArray = [];
      const captionsArray = [];
      let fileArrayIndex = 0;
      for (const file of files) {
        filesArray.push(
          new CustomFile(
            file.name,
            file.size,
            URL.createObjectURL(file),
            await readFileAsArrayBuffer(file),
          ),
        );
        captionsArray.push(
          fileArrayIndex === files.length - 1 ? formattedMessage[index] : "",
        );
        fileArrayIndex++;
      }
      console.debug("sent message to entity", index, " - ", channel.peerId);
      result = await client.sendFile(channel.peerId, {
        file: filesArray,
        forceDocument: true,
        parseMode: "html",
        caption: captionsArray,
      });
      await sleep(16);
    } catch (e) {
      console.log(e)
      Sentry.captureException(e);
      if (e.message?.startsWith("403")) {
        errors.CHAT_WRITE_FORBIDDEN++;
      } else if (e.message?.startsWith("400")) {
        errors.CHAT_ADMIN_REQUIRED++;
      } else {
        errors.OTHERS++;
      }
      errors.CHATS_WITH_ERRORS.push(channel);
      result = false;
    }

    if (result) {
      success++;
      linkToTg = channel.tgLink;
    }
    index++;
  }

  console.debug(errors);
  if (success !== 0) {
    dispatch(setWorkflowStep(0));
    dispatch(removeFolder());
    dispatch(removeMessage());
    return linkToTg;
  } else {
    return false;
  }
}
